import { AbstractControl, ValidatorFn, Validators } from '@angular/forms';

export function minTotalFilesIncludingProvidedMedia(
  media: readonly unknown[] | undefined | null,
  min: number,
): ValidatorFn {
  return (control: AbstractControl) => {
    const uploadedCount = Array.isArray(control.value) ? control.value.length : 0;
    const total = (media?.length ?? 0) + uploadedCount;

    if (total < min) {
      return {
        minTotalFiles: {
          required: min,
          actual: total,
        },
      };
    }

    return null;
  };
}

export function requiredFileListUnlessProvidedMedia(
  media: readonly unknown[] | undefined | null,
): ValidatorFn[] {
  return media?.length ? [] : [Validators.required];
}

export function hardLegallyBindingFilesArrayValidators(
  media: readonly unknown[] | undefined | null,
): ValidatorFn[] {
  return media?.length
    ? [Validators.maxLength(10)]
    : [Validators.required, Validators.minLength(1), Validators.maxLength(10)];
}
